import { createSlice } from '@reduxjs/toolkit';

const initialOrderState = {
  orderNo: '',
  orderDate: '',
  tableID: '',
  zoneID: '',
  delivery: 2,
  memberID: null,
  memberName: '',
  product: [],
  orderPrice: {
    sumprice: 0.0,
    discount: 0.0,
    vat: 0.0,
    net: 0.0
  },
  payment: [],
  tableDetails: null,
  billId: null,
  remark: ''
};

const initialState = {
  branch: null,
  pos: null,
  branchList: [],
  isAuthenticated: false,
  user: null,
  cashData: null,
  currentOrder: initialOrderState,
  orderId: null,
  currentBillData: {
    id: null,
    status: null,
    taxable_amount: 0,
    vat: 0,
    total_amount: 0
  },
  pendingTableOrder: null,
  shouldOpenPaymentModal: false
};

const posSlice = createSlice({
  name: 'pos',
  initialState,
  reducers: {
    setBranch: (state, action) => {
      state.branch = action.payload;
    },
    setBranchList: (state, action) => {
      state.branchList = action.payload;
    },
    setPOS: (state, action) => {
      state.pos = action.payload;
    },
    setUser: (state, action) => {
      state.user = action.payload;
      state.isAuthenticated = !!action.payload;
    },
    setCashData: (state, action) => {
      state.cashData = action.payload;
    },
    clearAuth: state => {
      state.branch = null;
      state.branchList = [];
      state.isAuthenticated = false;
      state.user = null;
    },
    setCurrentOrder: (state, action) => {
      state.currentOrder = action.payload;
    },
    updateCurrentOrder: (state, action) => {
      state.currentOrder = { ...state.currentOrder, ...action.payload };
    },
    resetCurrentOrder: state => {
      state.currentOrder = initialOrderState;
      state.orderId = null;
      state.currentBillData = {
        id: null,
        status: null,
        taxable_amount: 0,
        vat: 0,
        total_amount: 0
      };
      state.pendingTableOrder = null;
      state.shouldOpenPaymentModal = false;
    },
    addProductToOrder: (state, action) => {
      state.currentOrder.product.push(action.payload);
    },
    updateProductInOrder: (state, action) => {
      const { id, productData } = action.payload;
      const productIndex = state.currentOrder.product.findIndex(item => item.id === id);
      if (productIndex !== -1) {
        state.currentOrder.product[productIndex] = {
          ...state.currentOrder.product[productIndex],
          ...productData
        };
      }
    },
    removeProductFromOrder: (state, action) => {
      const productId = action.payload;
      state.currentOrder.product = state.currentOrder.product.filter(item => item.id !== productId);
    },
    markProductAsRemoved: (state, action) => {
      const productId = action.payload;
      const productIndex = state.currentOrder.product.findIndex(item => item.id === productId);
      if (productIndex !== -1) {
        state.currentOrder.product[productIndex].productStatus = 4;
      }
    },
    calculateOrderTotals: state => {
      const totalOrderAmount =
        state.currentOrder.product.length > 0
          ? state.currentOrder.product
              .filter(productItem => productItem.productStatus !== 4)
              .reduce((accumulator, productItem) => accumulator + parseFloat(productItem.displayPrice || 0), 0)
          : 0;

      state.currentOrder.orderPrice = {
        ...state.currentOrder.orderPrice,
        sumprice: totalOrderAmount,
        net: totalOrderAmount
      };
    },
    setOrderId: (state, action) => {
      state.orderId = action.payload;
    },
    setCurrentBillData: (state, action) => {
      state.currentBillData = action.payload;
    },
    updateCurrentBillData: (state, action) => {
      state.currentBillData = { ...state.currentBillData, ...action.payload };
    },
    setPendingTableOrder: (state, action) => {
      state.pendingTableOrder = action.payload;
    },
    processPendingTableOrder: state => {
      if (state.pendingTableOrder) {
        state.currentOrder = {
          ...state.currentOrder,
          tableID: state.pendingTableOrder.tableID,
          zoneID: state.pendingTableOrder.zoneID,
          delivery: state.pendingTableOrder.delivery,
          tableDetails: {
            tableID: state.pendingTableOrder.tableID,
            tableNo: state.pendingTableOrder.tableNo,
            zoneID: state.pendingTableOrder.zoneID,
            zoneName: state.pendingTableOrder.zoneName || ''
          }
        };
        state.pendingTableOrder = null;
      }
    },
    setShouldOpenPaymentModal: (state, action) => {
      state.shouldOpenPaymentModal = action.payload;
    }
  }
});

export const {
  setBranch,
  setBranchList,
  setPOS,
  setUser,
  setCashData,
  clearAuth,
  setCurrentOrder,
  updateCurrentOrder,
  resetCurrentOrder,
  addProductToOrder,
  updateProductInOrder,
  removeProductFromOrder,
  markProductAsRemoved,
  calculateOrderTotals,
  setOrderId,
  setCurrentBillData,
  updateCurrentBillData,
  setPendingTableOrder,
  processPendingTableOrder,
  setShouldOpenPaymentModal
} = posSlice.actions;

export default posSlice.reducer;